import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLuggage02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.965 2.136C10.476 2 11.067 2 11.862 2h.276c.795 0 1.386 0 1.897.136a4 4 0 0 1 2.829 2.829c.082.307.115.643.128 1.035h.25c.804 0 1.469 0 2.01.044.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v4.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H6.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C1 17.71 1 17.046 1 16.242v-4.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392C5.29 6 5.954 6 6.758 6h.25c.013-.392.046-.728.128-1.035a4 4 0 0 1 2.829-2.829Zm4.967 3.346c.032.12.049.26.058.518H9.01c.01-.258.026-.399.058-.518a2 2 0 0 1 1.414-1.414C10.705 4.008 11.006 4 12 4s1.295.009 1.518.068a2 2 0 0 1 1.414 1.414Zm-2.877 8.291C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.055.527a.5.5 0 0 0 .218.218c.107.055.247.055.527.055h4.9c.28 0 .42 0 .527-.055a.5.5 0 0 0 .218-.218c.055-.107.055-.247.055-.527v-2.4c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.218c-.107-.055-.247-.055-.527-.055h-4.9c-.28 0-.42 0-.527.055a.5.5 0 0 0-.218.218Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgLuggage02.displayName = 'Luggage02';
export default SvgLuggage02;
